module.exports = __webpack_public_path__ + "static/media/bg-boost-desktop.50d45915.svg";